import React, { useState, useEffect } from "react";
import { IconButton, useColorModeValue, Box } from "@chakra-ui/react";
import { FaArrowUp } from "react-icons/fa";

const BackToTopButton = () => {
  const [show, setShow] = useState(false);

  const handleScroll = () => {
    const position = window.pageYOffset;
    setShow(position > 300);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Box
      position="fixed"
      // bottom="100px"
      // right="30px"
      bottom={{ md: "100px", base: "80px" }}
      right={{ md: "30px" }}
      zIndex="999"
      display={{md: show ? "block" : "none", base: show ? "none" : "none"}}
    >
      <IconButton
        icon={<FaArrowUp />}
        colorScheme="cyan"
        aria-label="Scroll to top"
        borderRadius="full"
        size="lg"
        onClick={scrollToTop}
        shadow="lg"
        bg={useColorModeValue("cyan.500", "cyan.400")}
        color="white"
        _hover={{ bg: useColorModeValue("cyan.600", "cyan.500") }}
      />
    </Box>
  );
};

export default BackToTopButton;
